import { XProgress } from '@/components';

XProgress.configure({
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 500,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
});
/**
 * 路由加载进度条钩子函数
 * @param router
 */
export const useRouterLoading = (router) => {
    router.beforeEach((to, from, next) => {
        XProgress.start();
        return next();
    });

    router.afterEach(() => {
        XProgress.done();
    });
};
